import React from 'react';
import PropTypes from 'prop-types';

const ContentContainer = ({ children, ...props }) => <div className="content-container" {...props}>{children}</div>;

ContentContainer.propTypes = {
  children: PropTypes.any,
};

export default ContentContainer;
